import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { Subscription } from 'rxjs';
import { Commons } from '../../Commons';
import { CookieConsentService } from '../../../services/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent-banner',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule
  ],
  templateUrl: './cookie-consent-banner.component.html',
  styleUrl: './cookie-consent-banner.component.scss'
})
export class CookieConsentBannerComponent implements OnInit, OnDestroy {
  visible = false;
  private subscription = new Subscription();

  constructor(
    private cookieConsentService: CookieConsentService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    if (!Commons.isBrowser(this.platformId) || !this.cookieConsentService.hasTrackingConfigured()) {
      return;
    }

    this.visible = this.cookieConsentService.getConsent() === null;
    this.subscription.add(
      this.cookieConsentService.reopen$.subscribe(() => this.visible = true)
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  accept(): void {
    this.cookieConsentService.setConsent('accepted');
    this.visible = false;
  }

  reject(): void {
    this.cookieConsentService.setConsent('rejected');
    this.visible = false;
  }
}
